import { __extends } from "tslib";
import * as React from 'react';
import { classes, st } from './Price.st.css';
import { ProductLineItemDataHook } from '../../ProductLineItem';
var Price = /** @class */ (function (_super) {
    __extends(Price, _super);
    function Price() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Price.prototype.render = function () {
        var _a = this.props, formattedComparePrice = _a.formattedComparePrice, formattedPrice = _a.formattedPrice, className = _a.className;
        return (React.createElement("div", { className: st(classes.root, className) },
            formattedComparePrice && (React.createElement("span", { "data-hook": ProductLineItemDataHook.ComparePrice, className: classes.comparePrice }, formattedComparePrice)),
            formattedPrice && (React.createElement("span", { "data-hook": ProductLineItemDataHook.Price, className: classes.prices }, formattedPrice))));
    };
    Price.displayName = 'ProductLineItem.Price';
    return Price;
}(React.PureComponent));
export { Price };
//# sourceMappingURL=Price.js.map